import { render, staticRenderFns } from "./CustomerTransfers.vue?vue&type=template&id=54bddb1c&"
import script from "./CustomerTransfers.vue?vue&type=script&lang=js&"
export * from "./CustomerTransfers.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTransfers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3001884671/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54bddb1c')) {
      api.createRecord('54bddb1c', component.options)
    } else {
      api.reload('54bddb1c', component.options)
    }
    module.hot.accept("./CustomerTransfers.vue?vue&type=template&id=54bddb1c&", function () {
      api.rerender('54bddb1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/History/CustomerTransfers.vue"
export default component.exports